<template>
  <div class="accordion" :data-accordion-id="props.accordionId">
    <slot />
  </div>
</template>

<script setup>
const props = defineProps(['accordionId'])
</script>
